export const NOTIFICATION_PERMISSION = Object.freeze({
  DEFAULT: "default",
  GRANTED: "granted",
  DENIED: "denied",
});

export const NOTIFICATION_TEMPLATE_ACTION = {
  CREATE: "create",
  EDIT: "edit",
};

export const NOTIFICATION_TEMPLATE_TAGIFY_SETTINGS = {
  mixTagsInterpolator: ["{{", "}}"],
  pattern: /@/,
  dropdown: {
    enabled: 0,
    position: "text",
    mapValueTo: "label",
    highlightFirst: true,
    classname: "custom-tagify-dropdown",
  },
  whitelist: [],
  tagTextProp: "label",
  enforceWhitelist: true,
};

export const NOTIFICATION_TEMPLATES_COLUMNS = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    width: "25%",
  },
  {
    title: "Body",
    dataIndex: "body",
    key: "body",
    width: "25%",
  },
  {
    title: "Users & Roles",
    dataIndex: "usersAndRoles",
    key: "usersAndRoles",
  },
  {
    title: "created_at",
    dataIndex: "createdAt",
    key: "createdAt",
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
  },
];

export const SCHEDULED_NOTIFICATIONS_COLS = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Title",
    dataIndex: "title",
    key: "title",
    width: "15%",
  },
  {
    title: "Body",
    dataIndex: "body",
    key: "body",
    width: "25%",
  },
  {
    title: "Screen Name",
    dataIndex: "screenName",
    key: "screenName",
  },
  {
    title: "Notify_At",
    dataIndex: "notifyAt",
    key: "notifyAt",
  },
  {
    title: "Expire_At",
    dataIndex: "expireAt",
    key: "expireAt",
  },
  {
    title: "Sent_At",
    dataIndex: "sentAt",
    key: "sentAt",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Actions",
    dataIndex: "actions",
    key: "actions",
  },
];

export const SCHEDULED_NOTIFICATION_DATA_TYPE = Object.freeze({
  SKUS: "SKUs",
  BRANDS: "SKU Brands",
  SUBCATS: "SKU Subcategories",
  BUNDLES: "Bundles",
});

export const SCHEDULED_NOTIFICATION_DATA_TYPE_OPTIONS = Object.values(
  SCHEDULED_NOTIFICATION_DATA_TYPE
);
